import { updateObject } from './../../utils/utility';
import defaultMessages from '../../lang/messages/en.json';

const initialState = {
    activeMenuItemID: null,
    activeParentMenuItemID: null,
    activeHeaderMenuItemID: null,
    loading: false,
    authenticatedUser: false,
    modal: {
        open: false,
        content: null,
        title: "",
        type: null,
        error: false,
        errorSrc: ""
    },
    appModal: {
        open: false,
        content: null,
        style: null,
        title: "",
        type: null,
        messageId: "",
        messageText: "",
        errorMessageId: null,
        errorMessageText: "",
        footerContent: null,
        acceptHandler: null,
        rejectHandler: null,
        closeHandler: null,
        rounded: false,
        maxWidth: null,
        hideHeader: false,
        showSpinner: false,
        toBeHidden: false
    },
    drawerOpen: false,
    warnUserBeforeExit: false,
    mobileView: false,
    messages: defaultMessages,
    messagesReceived: false
};

const setVerticalMenuActiveItem = (state = initialState, action) => {
    return updateObject(state, {
        activeMenuItemID: action.data
    });
}

const setVerticalParentMenuActiveItem = (state = initialState, action) => {
    return updateObject(state, {
        activeParentMenuItemID: action.data
    });
}

const setHeaderMenuActiveItem = (state = initialState, action) => {
    return updateObject(state, {
        activeHeaderMenuItemID: action.data
    });
}

const setLoading = (state = initialState, action) => {
    return updateObject(state, {
        loading: action.data
    });
}

const setMobileView = (state = initialState, action) => {
    return updateObject(state, {
        mobileView: action.data
    });
}

const setModal = (state = initialState, action) => {
    return updateObject(state, {
        modal: action.data
    });
}

const setAppModal = (state = initialState, action) => {
    let modalData = { ...action.data };
    if (modalData.open === false) {
        return updateObject(state, {
            appModal: updateObject(state.appModal, initialState.appModal)
        });
    }

    if (modalData.type === "error" || modalData.type === "info" || modalData.type === "confirm" || modalData.type === "feedback") {
        modalData.open = true;
    }
    if (!modalData.customTextClass) {
        modalData.customTextClass = "";
    }
    // if(modalData.toBeHidden === undefined || modalData.toBeHidden === null)modalData.toBeHidden=false;

    return updateObject(state, {
        appModal: updateObject(state.appModal, modalData)
    });
}

const closeAppModal = (state = initialState, action) => {
    let modalData = { ...action.data };
    return updateObject(state, {
        appModal: updateObject(state.appModal, initialState.appModal)
    });

}

const setDrawerOpen = (state = initialState, action) => {
    return updateObject(state, {
        drawerOpen: action.data
    });
}

const setWarnUserBeforeExit = (state = initialState, action) => {
    return updateObject(state, {
        warnUserBeforeExit: action.data
    });
}

const setModalState = (state = initialState, action) => {
    if (state.modal.hasOwnProperty("open")) {
        return {
            ...state,
            modal: {
                ...state.modal,
                open: false
            }
        }
    }
}

const setMessages = (state = initialState, action) => {
    return updateObject(state, {
        messages: action.data,
        messagesReceived: true
    });
}

const setModalSpinner = (state = initialState, action) => {
    return updateObject(state, {
        appModal: updateObject(state.appModal, { showSpinner: action.data })
    });
}

const setModalErrorMessageId = (state = initialState, action) => {
    return updateObject(state, {
        appModal: updateObject(state.appModal, { errorMessageId: action.data })
    });
}

const setInquiryModal = (state = initialState, action) => {
    return updateObject(state, {
        appModal: updateObject(state.appModal,
            {
                type: action.data.type,
                content: action.data.content,
                open: action.data.open,
                rounded: true,
                hideHeader: true,
                maxWidth: action.data.maxWidth
            })
    });
}

const reducer = (state = initialState, action) => {
    if (action.type === "SET_VERTICAL_MENU_ACTIVE_ITEM") {
        return setVerticalMenuActiveItem(state, action);
    }
    if (action.type === "SET_VERTICAL_PARENT_MENU_ACTIVE_ITEM") {
        return setVerticalParentMenuActiveItem(state, action);
    }
    if (action.type === "SET_HEADER_MENU_ACTIVE_ITEM") {
        return setHeaderMenuActiveItem(state, action);
    }
    if (action.type === "SET_LOADING") {
        return setLoading(state, action);
    }
    if (action.type === "SET_MODAL") {
        return setModal(state, action);
    }
    if (action.type === "SET_MODAL_STATE") {
        return setModalState(state, action);
    }
    if (action.type === "SET_APP_MODAL") {
        return setAppModal(state, action);
    }
    if (action.type === "CLOSE_APP_MODAL") {
        return closeAppModal(state, action);
    }
    if (action.type === "SET_DRAWER_OPEN") {
        return setDrawerOpen(state, action);
    }
    if (action.type === "SET_WARN_USER_BEFORE_EXIT") {
        return setWarnUserBeforeExit(state, action);
    }
    if (action.type === "SET_MOBILE_VIEW") {
        return setMobileView(state, action);
    }
    if (action.type === "SET_MESSAGES") {
        return setMessages(state, action);
    }
    if (action.type === "SET_MODAL_SPINNER") {
        return setModalSpinner(state, action);
    }
    if (action.type === "SET_MODAL_ERROR_MESSAGE_ID") {
        return setModalErrorMessageId(state, action);
    }
    if (action.type === "SET_INQUIRY_MODAL") {
        return setInquiryModal(state, action);
    }
    return state;
}

export default reducer;
